import styled from 'styled-components';
import PageEmptyState from '@/components/PageEmptyState';

export const Header = styled.div`
  height: 42px;
  margin-bottom: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    margin-top: -10px;
    align-items: center;
  }
`;

export const EmptyState = styled(PageEmptyState)`
  height: calc(100vh - 320px);
`;
